import React, { useEffect } from "react";
import "./updateRequiredModal.styles.scss";

const UpdateRequiredModal = ({ show }) => {
  useEffect(() => {
    if (!show) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
      }
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [show]);

  if (!show) {
    return null;
  }

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="update-required-modal" role="dialog" aria-modal="true">
      <div className="update-required-modal__backdrop" />
      <div className="update-required-modal__content">
        <h2 className="update-required-modal__title">Nueva versión disponible</h2>
        <p className="update-required-modal__text">
          Hay una nueva versión de la tienda. Actualiza para continuar.
        </p>
        <button
          type="button"
          className="update-required-modal__button"
          onClick={handleReload}
        >
          Actualizar
        </button>
      </div>
    </div>
  );
};

export default UpdateRequiredModal;
